import { useRef, KeyboardEvent } from 'react';
import { SendHorizonal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export function ChatInput({ onSend, disabled }: ChatInputProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  function handleKeyDown(e: KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  }

  function submit() {
    const value = ref.current?.value.trim();
    if (!value || disabled) return;
    onSend(value);
    if (ref.current) ref.current.value = '';
    // Reset height after clearing
    if (ref.current) ref.current.style.height = 'auto';
  }

  function handleInput() {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 112)}px`; // max ~4 rows
  }

  return (
    <div className="flex gap-2 items-end p-3 border-t bg-background">
      <Textarea
        ref={ref}
        placeholder="Ask me anything about MoldOp..."
        aria-label="Type a message"
        className="resize-none min-h-[40px] max-h-28 flex-1 text-sm leading-snug py-2"
        rows={1}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        onInput={handleInput}
      />
      <Button
        size="icon"
        className="shrink-0 h-9 w-9"
        onClick={submit}
        disabled={disabled}
        aria-label="Send message"
      >
        <SendHorizonal className="h-4 w-4" />
      </Button>
    </div>
  );
}
